import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import {
  obtenerUbicacionArticulo,
  mensajeUbicacionArticulo,
  alternativasMismoArticulo,
} from "../../../../utils/ubicacionArticulo";

function PedidosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_INVENTARIOS_BODEGA_PEDIDO = import.meta.env.VITE_URL_INVENTARIOS_DISPONIBLE_BODEGA_PEDIDO;
  const URL_ARTICULOS = import.meta.env.VITE_URL_ARTICULOS;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_PEDIDOS = import.meta.env.VITE_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = import.meta.env.VITE_URL_ARTICULOS_PEDIDO;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_PAQUETERIAS = import.meta.env.VITE_URL_PAQUETERIAS;
  const URL_SEND_MAIL = import.meta.env.VITE_URL_SEND_MAIL;
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;
  const URL_ARTICULOS_PROPORCION = import.meta.env
    .VITE_URL_ARTICULOS_PROPORCION;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [value, setValue] = useState(null);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [inventarios, setInventarios] = useState([]);
  const [inventariosLoaded, setInventariosLoaded] = useState(false);
  // Se distingue "no hay existencia" de "no pude consultar el inventario":
  // antes ambos casos terminaban en el mismo mensaje y no habia forma de saber
  // si faltaba mercancia o si la consulta habia fallado.
  const [inventariosError, setInventariosError] = useState(false);

  const [clienteNombre, setClienteNombre] = useState("");
  const [cliente, setCliente] = useState("");
  const [departamentoCliente, setDepartamentoCliente] = useState("");
  const [paqueterias, setPaqueterias] = useState([]);
  const [idPaqueteria, setIdPaqueteria] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("6201b18c0f94f86068a741c0");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);

  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);

  const [descuento, setDescuento] = useState(0);
  const [descuentoImporte, setDescuentoImporte] = useState(0);
  // Refs para evitar que el cambio de estado de uno dispare re-cálculo del otro
  const descuentoRef = useRef(0);
  const descuentoImporteRef = useRef(0);
  const discountModeRef = useRef('percent'); // 'percent' | 'amount'
  const [listaPrecios, setListaPrecios] = useState(1);

  const [inputFields, setInputFields] = useState([
    // {
    //   id: uuidv4(),
    //   articulos: "",
    //   cantidad: 0,
    //   precio: 0,
    //   precioOriginal: 0,
    //   total: 0,
    //   articulosNombre: "",
    //   idColor: "",
    //   colorNombre: "",
    //   idTalla: "",
    //   tallaNombre: "",
    //   colores: [],
    //   tallas: [],
    // },
  ]);
  const [expandedTables, setExpandedTables] = useState({});

  const [manualInput, setManualInput] = useState({
    articulosNombre: "",
    articulos: "",
    idColor: "",
    idTalla: "",
    tallaNombre: "",
    cantidad: 0,
    precio: 0,
    colores: [],
    tallas: [],
    total: 0,
    precioEsp: "No",
  });

  // Ref para el input del scanner (uncontrolled para evitar race conditions con la pistola)
  const scannerInputRef = useRef(null);

  // Estados para manejar fotos de productos
  const [productPhotos, setProductPhotos] = useState({}); // {articuloId: photoVersion}
  const [loadingPhotos, setLoadingPhotos] = useState({}); // {articuloId: boolean}

  // Función helper para generar opciones de precios disponibles
  const getPriceOptions = (articulo) => {
    if (!articulo) return [];

    const formatPrice = (precio) => {
      const num = Number(precio) || 0;
      return num.toFixed(2);
    };

    const options = [
      { value: articulo.listaPrecioPieza || 0, label: `$${formatPrice(articulo.listaPrecioPieza)} Pieza`, tipo: 'pieza' },
      { value: articulo.listaPrecioCorrida || 0, label: `$${formatPrice(articulo.listaPrecioCorrida)} Corrida`, tipo: 'corrida' },
      { value: articulo.listaPrecioPaquete || 0, label: `$${formatPrice(articulo.listaPrecioPaquete)} Paquete`, tipo: 'paquete' },
      { value: articulo.listaPrecioCaja || 0, label: `$${formatPrice(articulo.listaPrecioCaja)} Caja`, tipo: 'caja' },
      { value: articulo.listaPrecioRebajas || 0, label: `$${formatPrice(articulo.listaPrecioRebajas)} Rebajas`, tipo: 'rebajas' }
    ];

    // Filtrar duplicados y precios en 0
    return options.filter((option, index, self) =>
      option.value > 0 && index === self.findIndex(o => o.value === option.value)
    );
  };

  // Componente para seleccionar precios (input normal o dropdown para precio especial)
  const PriceSelector = ({ articulo, currentPrice, onChange, disabled, name, ...props }) => {
    if (!articulo || articulo.precioEsp !== "Si") {
      // Mostrar input normal para artículos sin precio especial
      return (
        <Input
          name={name}
          type="number"
          min="0"
          step="any"
          value={currentPrice || 0}
          disabled={disabled}
          onChange={onChange}
          {...props}
        />
      );
    }

    // Mostrar dropdown para artículos con precio especial
    const options = getPriceOptions(articulo);
    return (
      <Input
        name={name}
        type="select"
        value={currentPrice || ""}
        onChange={onChange}
        {...props}
      >
        <option value="">Selecciona precio</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
    );
  };

  // Función helper para obtener precio según lista de precios
  const getPrecioSegunLista = (articulo, lista) => {
    const listaNum = Number(lista);
    switch (listaNum) {
      case 1:
        return articulo.listaPrecioPieza || 0;
      case 2:
        return articulo.listaPrecioCorrida || 0;
      case 3:
        return articulo.listaPrecioPaquete || 0;
      case 4:
        return articulo.listaPrecioCaja || 0;
      case 5:
        return articulo.listaPrecioRebajas || 0;
      default:
        return articulo.listaPrecioPieza || 0;
    }
  };

  // Función para obtener foto del producto
  const fetchProductPhoto = async (articuloId) => {
    if (productPhotos[articuloId] || loadingPhotos[articuloId]) return;
    
    setLoadingPhotos(prev => ({...prev, [articuloId]: true}));
    
    try {
      const URL_GET_MEDIA = `${import.meta.env.VITE_URL_GETMEDIA}/${articuloId}`;
      const response = await axios.get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      
      if (response.data.secure_url) {
        setProductPhotos(prev => ({
          ...prev,
          [articuloId]: response.data.secure_url
        }));
      } else if (response.data.version) {
        setProductPhotos(prev => ({
          ...prev,
          [articuloId]: response.data.version
        }));
      }
    } catch (err) {
      console.log('Error fetching photo:', err);
    } finally {
      setLoadingPhotos(prev => ({...prev, [articuloId]: false}));
    }
  };

  const handleManualArticuloChange = (selectedArticulo) => {
    if (selectedArticulo) {
      const precioArt = getPrecioSegunLista(selectedArticulo, listaPrecios);

      // Obtener foto del producto
      fetchProductPhoto(selectedArticulo._id);

      // Antes se filtraban los colores dejando solo los que tenian disponible > 0.
      // El efecto secundario era que si el inventario no habia cargado (la consulta
      // tarda varios segundos) o habia fallado, el desplegable quedaba VACIO sin
      // ningun aviso, y parecia que el articulo no existia. Ahora se ofrecen todos
      // los colores del articulo y el rechazo se explica al intentar agregar, con
      // el desglose de en que almacen esta la mercancia.
      const coloresRed = selectedArticulo.colores || [];

      setManualInput({
        articulos: selectedArticulo._id,
        articulosNombre: selectedArticulo.codigo + " " + selectedArticulo.nombre,
        precio: precioArt,
        colores: coloresRed,
        tallas: [],
        // Tallas del catalogo del articulo, para poder ofrecerlas aunque el
        // inventario todavia no haya cargado o no tenga existencia.
        tallasArticulo: selectedArticulo.tallas || [],
        idColor: "",
        idTalla: "",
        cantidad: 0,
        idProporcion: "",
        precioEsp: selectedArticulo.precioEsp || "No",
      });
    }
  };

  const ActualizaTotales = useCallback(() => {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    // Calcular descuento según el modo activo, usando refs para evitar ciclos
    let descImporte;
    if (discountModeRef.current === 'amount') {
      // $ fijo: mantener el importe exacto del usuario, actualizar %
      descImporte = descuentoImporteRef.current;
      if (TG > 0) {
        const newPct = parseFloat(((descImporte / TG) * 100).toFixed(2));
        setDescuento(newPct);
        descuentoRef.current = newPct;
      }
    } else {
      // % fijo: recalcular $ desde el porcentaje
      descImporte = parseFloat(((TG * descuentoRef.current) / 100).toFixed(2));
      setDescuentoImporte(descImporte);
      descuentoImporteRef.current = descImporte;
    }

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      descImporte;

    setTotalGeneral(totTemp);
  }, [
    inputFields,
    selectedImpuesto,
    comisionTDC,
    comisionFlete,
  ]);

  useEffect(() => {
    ActualizaTotales();
  }, [inputFields, ActualizaTotales]);

  // Helper function to check inventory availability
  const checkInventoryAvailability = (idArticulo, idColor, idTalla, requestedQuantity) => {
    // Antes, mientras el inventario no cargaba se devolvia disponible:999, lo que
    // dejaba pasar cualquier cantidad. Ahora se detiene y se dice el motivo real.
    if (!inventariosLoaded) {
      return {
        available: false,
        availableQuantity: 0,
        motivo: "cargando",
        message: "Todavía se está consultando el inventario. Espera unos segundos e intenta de nuevo.",
      };
    }

    if (inventariosError) {
      return {
        available: false,
        availableQuantity: 0,
        motivo: "error",
        message: "No se pudo consultar el inventario. Reintenta o recarga la pantalla.",
      };
    }

    const inventoryItem = inventarios.find(
      (inv) =>
        String(inv.idArticulo) === String(idArticulo) &&
        String(inv.idColor) === String(idColor) &&
        String(inv.idTalla) === String(idTalla)
    );

    // motivo "sinExistencia" habilita el desglose por almacen en el mensaje:
    // la mercancia puede existir, pero en otra bodega o apartada en pedidos.
    if (!inventoryItem) {
      return {
        available: false,
        availableQuantity: 0,
        motivo: "sinExistencia",
        message: "No hay existencia disponible de esta combinación en las bodegas",
      };
    }

    if (inventoryItem.disponible <= 0) {
      return {
        available: false,
        availableQuantity: inventoryItem.disponible,
        motivo: "sinExistencia",
        message: "No hay existencia disponible de esta combinación en las bodegas",
      };
    }

    if (requestedQuantity > inventoryItem.disponible) {
      return {
        available: false,
        availableQuantity: inventoryItem.disponible,
        message: `Solo hay ${inventoryItem.disponible} piezas disponibles`
      };
    }

    return { available: true, availableQuantity: inventoryItem.disponible, message: "" };
  };

  /**
   * Muestra el rechazo explicando el motivo real.
   *
   * Cuando el problema es falta de existencia, consulta en que almacen esta la
   * mercancia y lo muestra, para que el usuario sepa si tiene que pedir un
   * traspaso en lugar de suponer que el articulo no existe.
   */
  const avisarRechazoInventario = async (
    inventoryCheck,
    idArticulo,
    idColor,
    idTalla
  ) => {
    if (inventoryCheck.motivo !== "sinExistencia") {
      Swal.fire({
        icon: inventoryCheck.motivo === "cargando" ? "info" : "error",
        title:
          inventoryCheck.motivo === "cargando"
            ? "Inventario en consulta"
            : "No se pudo consultar el inventario",
        text: inventoryCheck.message,
        showConfirmButton: true,
      });
      return;
    }

    Swal.fire({
      title: "Consultando existencia...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const ubicacion = await obtenerUbicacionArticulo(
      URL_INVENTARIOS,
      idArticulo,
      idColor,
      idTalla
    );

    Swal.fire({
      icon: "warning",
      title: "Sin existencia disponible",
      html: mensajeUbicacionArticulo({
        ubicacion,
        idAreaActual: null,
        nombreAreaActual: null,
        articulo: manualInput.articulosNombre,
        color: manualInput.colorNombre,
        talla: manualInput.tallaNombre,
        alternativas: alternativasMismoArticulo(
          inventarios,
          idArticulo,
          idColor,
          idTalla
        ),
      }),
      showConfirmButton: true,
    });
  };

  const handleManualInputChange = (event) => {
    const { name, value } = event.target;

    setManualInput((prev) => {
      const updatedInput = {
        ...prev,
        [name]: value,
      };

      // Las tallas se toman del catalogo del articulo, no del inventario.
      // Derivarlas del inventario dejaba el desplegable vacio cuando la consulta
      // de disponibilidad no habia respondido o habia fallado, y el usuario no
      // tenia manera de distinguir eso de "no hay existencia". La validacion de
      // existencia sigue ocurriendo al agregar y al guardar.
      if (name === "idColor") {
        updatedInput.tallas = (prev.tallasArticulo || [])
          .filter(Boolean)
          .map((t) => ({ _id: t._id, name: t.name }));
        updatedInput.idTalla = "";
        updatedInput.tallaNombre = "";
      }

      // If changing talla, update tallaNombre
      if (name === "idTalla") {
        const selectedTalla = (updatedInput.tallas || prev.tallas || []).find((t) => t._id === value);
        updatedInput.tallaNombre = selectedTalla ? selectedTalla.name : "";
      }

      // Calculate total whenever cantidad or precio changes
      if (name === "cantidad") {
        updatedInput.cantidad = parseFloat(value);
        updatedInput.total = parseFloat(value) * prev.precio;

        // Check inventory availability when quantity changes
        if (prev.articulos && prev.idColor && prev.idTalla && parseFloat(value) > 0) {
          const inventoryCheck = checkInventoryAvailability(
            prev.articulos,
            prev.idColor,
            prev.idTalla,
            parseFloat(value)
          );

          if (!inventoryCheck.available) {
            Swal.fire({
              icon: "error",
              title: "Inventario insuficiente",
              text: inventoryCheck.message,
              showConfirmButton: true,
            });
          }
        }
      }

      // Calculate total whenever precio changes
      if (name === "precio") {
        updatedInput.precio = parseFloat(value);
        updatedInput.total = prev.cantidad * parseFloat(value);
      }

      return updatedInput;
    });
  };

  const handleManualAdd = async () => {
    if (
      !manualInput.articulosNombre ||
      !manualInput.idColor ||
      !manualInput.idTalla ||
      !manualInput.cantidad
    ) {
      return;
    }

    // Check inventory availability before proceeding
    const inventoryCheck = checkInventoryAvailability(
      manualInput.articulos,
      manualInput.idColor,
      manualInput.idTalla,
      parseFloat(manualInput.cantidad)
    );

    if (!inventoryCheck.available) {
      await avisarRechazoInventario(
        inventoryCheck,
        manualInput.articulos,
        manualInput.idColor,
        manualInput.idTalla
      );
      return;
    }

    let res;

    try {
      res = await axios.get(
        `${URL_ARTICULOS_PROPORCION}/ArticuloColorTalla/${manualInput.articulos}/${manualInput.idColor}/${manualInput.idTalla}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
    } catch (err) {
      console.log(err);
    }

    if (!res || !res.data || res.data.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se encontró el artículo con la talla y color seleccionados",
        showConfirmButton: false,
      });
      return;
    }
    const idArticuloProporcion = res.data[0]._id;

    const avaible = inputFields.find(
      (i) => i.idArticuloProporcion === idArticuloProporcion
    );

    if (avaible) {
      // Check if adding more quantity would exceed inventory
      const newTotalQuantity = avaible.cantidad + manualInput.cantidad;
      const inventoryCheck = checkInventoryAvailability(
        manualInput.articulos,
        manualInput.idColor,
        manualInput.idTalla,
        newTotalQuantity
      );

      if (!inventoryCheck.available) {
        Swal.fire({
          icon: "error",
          title: "Inventario insuficiente",
          text: inventoryCheck.message,
          showConfirmButton: true,
        });
        return;
      }

      // Create new array with updated object
      const updatedFields = inputFields.map((field) => {
        if (field.idArticuloProporcion === idArticuloProporcion) {
          return {
            ...field,
            cantidad: field.cantidad + manualInput.cantidad,
            total: (field.cantidad + manualInput.cantidad) * field.precio,
          };
        }
        return field;
      });

      setInputFields(updatedFields);
      // Reset only specific fields after adding
      setManualInput((prev) => ({
        ...prev,
        idColor: "",
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        idTalla: "",
        tallaNombre: "",
        total: 0,
        idProporcion: "",
        precioEsp: "No",
      }));

      return null;
    }

    const selectedColor = manualInput.colores.find(
      (c) => String(c._id) === String(manualInput.idColor)
    );
    const selectedTalla = manualInput.tallas.find(
      (t) => String(t._id) === String(manualInput.idTalla)
    );

    const newField = {
      id: uuidv4(),
      articulos: manualInput.articulos,
      articulosNombre: manualInput.articulosNombre,
      precio: manualInput.precio,
      precioOriginal: manualInput.precio,
      cantidad: parseFloat(manualInput.cantidad),
      idTalla: manualInput.idTalla,
      tallaNombre: selectedTalla ? selectedTalla.name : "",
      idColor: manualInput.idColor,
      colorNombre: selectedColor ? selectedColor.name : "",
      total: manualInput.cantidad * manualInput.precio,
      colores: manualInput.colores,
      tallas: manualInput.tallas,
      idArticuloProporcion: idArticuloProporcion,
      precioEsp: manualInput.precioEsp || "No",
    };

    setInputFields((prev) => [...prev, newField]);

    // Reset only specific fields after adding
    setManualInput((prev) => ({
      ...prev,
      idColor: "",
      articulos: "",
      articulosNombre: "",
      cantidad: 0,
      idTalla: "",
      tallaNombre: "",
      precio: 0,
      total: 0,
      idProporcion: "",
      precioEsp: "No",
    }));
  };

  const [inputArticulos, setInputArticulos] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cajas: 0,
      precio: 0,
      articulosNombre: "",
      colores: [],
      tallas: [],
      EAN: "",
      precioEsp: "No",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  const [mailAutEnviado, setMailAutEnviado] = useState(false);
  const [randomCambiaPrecio, setRandomCambiaPrecio] = useState(
    (Math.random() + 1).toString(36).substring(2)
  );

  useEffect(() => {
    axios
      .get(`${URL_ARTICULOS}Activos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CLIENTES}Activos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_PAQUETERIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allPaqueterias = res.data;
        setPaqueterias(allPaqueterias);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

    // Obtener inventario disponible solo de bodegas para pedidos
    axios
      .get(URL_INVENTARIOS_BODEGA_PEDIDO, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDisponible = response.data;
        setInventarios(allDisponible);
        setInventariosError(false);
        setInventariosLoaded(true);
      })
      .catch((err) => {
        console.log(err);
        setInventariosError(true);
        setInventariosLoaded(true);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const savePedido = async (event) => {
    event.preventDefault();

    // Validate that there are items to save
    const validItems = inputFields.filter(item => item.articulos && item.cantidad > 0);
    if (validItems.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Sin artículos",
        text: "Debes agregar al menos un artículo para crear el pedido",
      });
      return;
    }

    let cantidadIF = inputFields.length;
    let contador = 0;

    // First, validate inventory for all items
    const inventoryErrors = [];
    for (const item of inputFields) {
      if (item.articulos && item.idColor && item.idTalla && item.cantidad > 0) {
        const inventoryCheck = checkInventoryAvailability(
          item.articulos,
          item.idColor,
          item.idTalla,
          item.cantidad
        );

        if (!inventoryCheck.available) {
          inventoryErrors.push(`${item.articulosNombre} - ${item.colorNombre} - ${item.tallaNombre}: ${inventoryCheck.message}`);
        }
      }
    }

    if (inventoryErrors.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Inventario insuficiente",
        html: `<div style="text-align: left;">Los siguientes artículos no tienen suficiente inventario:<br><br>${inventoryErrors.join('<br>')}</div>`,
        showConfirmButton: true,
      });
      return;
    }

    if (cambiarPrecio === false && user.precio_menor === false) {
      inputFields.forEach((a) => {
        if (a.precioOriginal - 51 < a.precio || a.precioEsp === "Si") {
          contador = contador + 1;
        }
      });
    } else {
      contador = inputFields.length;
    }

    if (contador === cantidadIF) {
      if (selectedCliente !== "" && selectedArea !== "") {
        setValidaBoton(false);
        toggleProgreso();

        try {
          const articulos = inputFields
            .filter((a) => a.articulos !== "" && a.cantidad !== 0)
            .map((a) => ({
              fecha,
              articulos: a.articulos,
              colores: a.idColor,
              tallas: a.idTalla,
              clientes: selectedCliente,
              cantidad: parseFloat(a.cantidad),
              surtido: 0,
              pendiente_surtir: parseFloat(a.cantidad),
              precio: parseFloat(parseFloat(a.precio).toFixed(2)),
              total: parseFloat(parseFloat(a.total).toFixed(2)),
              autorizadoSurtido: "No",
              autorizadoApartado: "Si",
              observaciones: "NA",
              articulosProporcion: a.idArticuloProporcion,
            }));

          await axios.post(
            `${URL_PEDIDOS}/with-articulos`,
            {
              fecha,
              clientes: selectedCliente,
              departamentosClientes: departamentoCliente,
              colaboradores: selectedColaborador,
              total_general: parseFloat(total_general).toFixed(2),
              observaciones,
              total_cantidad,
              paqueterias: idPaqueteria,
              areas: selectedArea,
              comisionTDC,
              comisionFlete,
              subTotal: parseFloat(subTotal).toFixed(2),
              iva: parseFloat(iva).toFixed(2),
              impuestos: selectedImpuesto,
              surtido: "No",
              autorizadoApartado: "Si",
              autorizadoSurtido: "No",
              editado: "No",
              fechaModificado: fecha,
              creado: user.id,
              fecha_estimada: fecha,
              fecha_entrega: fecha,
              entregaInsumos: "No",
              descuento,
              descuentoImporte,
              abonos: 0,
              saldo: parseFloat(total_general).toFixed(2),
              user: user.id,
              articulos,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          Swal.fire("Good job!", "Creado con exito", "success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error al crear pedido",
            text:
              error.response?.data?.message ||
              error.message ||
              "Ocurrió un error al crear el pedido",
            footer: error.response?.data
              ? JSON.stringify(error.response.data)
              : "",
          });
          console.error("Error creando pedido:", error);
          setValidaBoton(true);
          toggleProgreso();
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Faltan datos, favor de revisar",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No puedes vender $50 menos del precio original",
        showConfirmButton: false,
      });
    }
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        precio: 0,
        precioOriginal: 0,
        total: 0,
        articulosNombre: "",
        idColor: "",
        colorNombre: "",
        idTalla: "",
        tallaNombre: "",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];

    // Find the field to remove by ID to get its article and color ID
    const fieldToRemove = values.find((value) => value.id === id);

    if (!fieldToRemove) {
      console.log("No se encontró el campo a eliminar con id:", id);
      return;
    }

    // Remove all fields with the same article and color ID combination
    const filteredValues = values.filter((value) =>
      !(String(value.articulos) === String(fieldToRemove.articulos) &&
        String(value.idColor) === String(fieldToRemove.idColor))
    );

    setInputFields(filteredValues);

    // Recalcular totales
    let totalCan = filteredValues.map((c) => parseFloat(c.cantidad));
    let TC = totalCan.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let importes = filteredValues.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    let ivaTemp = 0;
    if (selectedImpuesto !== 0) {
      ivaTemp = (selectedImpuesto * TG) / 100;
      setIva(ivaTemp);
    } else {
      setIva(0);
    }

    let descImporte;
    if (discountModeRef.current === 'amount') {
      descImporte = descuentoImporteRef.current;
    } else {
      descImporte = parseFloat(((TG * descuentoRef.current) / 100).toFixed(2));
      setDescuentoImporte(descImporte);
      descuentoImporteRef.current = descImporte;
    }

    setTotalGeneral(
      ivaTemp +
        TG +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete) -
        descImporte
    );
  };

  // Función para manejar cambios de precio en grupos (artículo + color)
  const handleGroupPriceChange = (groupId, event) => {
    const newPrice = parseFloat(event.target.value) || 0;
    
    // Encontrar el elemento del grupo para obtener artículo y color
    const groupItem = inputFields.find(item => item.id === groupId);
    if (!groupItem) return;

    // Actualizar todos los elementos que tienen el mismo artículo y color
    const newInputFields = inputFields.map((item) => {
      if (String(item.articulos) === String(groupItem.articulos) && String(item.idColor) === String(groupItem.idColor)) {
        return {
          ...item,
          precio: newPrice,
          total: parseFloat(item.cantidad) * newPrice
        };
      }
      return item;
    });

    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        const updated = { ...i, [event.target.name]: event.target.value };
        // Recalcular total cuando cambie precio o cantidad
        if (event.target.name === 'precio' || event.target.name === 'cantidad') {
          let totalParcial = parseFloat(updated.cantidad) * parseFloat(updated.precio);
          updated.total = totalParcial;
        }
        return updated;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        return {
          ...i,
          [event.target.name]: event.target.value,
          precio: event.target.value
        };
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
    ActualizaTotales();
  };

  function BuscaCodigoProporcion(id, event) {
    if (event.target.value.length > 1) {
      const foundArticle = articulos.find((a) => a.EAN === event.target.value);

      if (foundArticle) {
        const idArticulo = foundArticle._id;
        const articulosNombre = `${foundArticle.codigo} ${foundArticle.nombre}`;
        const colores = foundArticle.colores;
        const tallas = foundArticle.tallas;
        const precioArt = getPrecioSegunLista(foundArticle, listaPrecios);

        handleChangeInputArticuloProporcion(
          id,
          idArticulo,
          precioArt,
          articulosNombre,
          colores,
          tallas,
          event.target.value,
          foundArticle.precioEsp || "No"
        );
      } else {
        Swal.fire({
          icon: "error",
          title: "Artículo no encontrado",
          text: "No se encontró ningún artículo con el código proporcionado",
        });
      }
    }
  }

  const handleChangeInputCantidad = (id, event) => {
    const newQuantity = parseFloat(event.target.value) || 0;

    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        // Check inventory availability before updating quantity
        if (newQuantity > 0) {
          const inventoryCheck = checkInventoryAvailability(
            i.articulos,
            i.idColor,
            i.idTalla,
            newQuantity
          );

          if (!inventoryCheck.available) {
            Swal.fire({
              icon: "error",
              title: "Inventario insuficiente",
              text: inventoryCheck.message,
              showConfirmButton: true,
            });
            return i; // Return unchanged item
          }
        }

        // Create a new object to avoid direct mutation
        const totalParcial = newQuantity * i.precio;
        return {
          ...i,
          cantidad: newQuantity,
          total: totalParcial
        };
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, selectedArticulo) {
    articulos.map((a) => {
      if (a._id === selectedArticulo._id) {
        let idArticulo = selectedArticulo._id;
        let piezasPorCaja = a.piezasPorCaja;
        let precio = a.venta;
        let precioOriginal = a.venta;
        let articulosNombre = selectedArticulo.codigo;
        let colores = a.colores;
        let tallas = a.tallas;
        handleChangeInputArticulo(
          id,
          idArticulo,
          piezasPorCaja,
          precio,
          precioOriginal,
          articulosNombre,
          colores,
          tallas
        );
      }
    });
  }

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    piezasPorCaja,
    precio,
    precioOriginal,
    articulosNombre,
    colores,
    tallas
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        const totalParcial = i.cantidad * precio;
        return {
          ...i,
          articulos: idArticulo,
          piezasPorCaja,
          precio,
          total: totalParcial,
          articulosNombre,
          precioOriginal,
          colores,
          tallas
        };
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
    handleAddFields();
  };

  function calculaDescuento(e) {
    discountModeRef.current = 'percent';
    const pct = parseFloat(e) || 0;
    setDescuento(pct);
    descuentoRef.current = pct;
    const descImporte = parseFloat(((subTotal * pct) / 100).toFixed(2));
    setDescuentoImporte(descImporte);
    descuentoImporteRef.current = descImporte;
    const totTemp =
      parseFloat(iva) +
      subTotal +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      descImporte;
    setTotalGeneral(totTemp);
  }

  function calculaDescuentoImporte(e) {
    discountModeRef.current = 'amount';
    const val = parseFloat(parseFloat(e || 0).toFixed(2));
    setDescuentoImporte(val);
    descuentoImporteRef.current = val;
    // Actualizar % solo para display — NO dispara ActualizaTotales
    const pct = subTotal > 0 ? parseFloat(((val / subTotal) * 100).toFixed(2)) : 0;
    setDescuento(pct);
    descuentoRef.current = pct;
    // Calcular total con el valor exacto ingresado por el usuario
    const totTemp =
      (selectedImpuesto * subTotal) / 100 +
      subTotal +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      val;
    setTotalGeneral(totTemp);
  }

  const options = useMemo(() => {
    return articulos
      .filter((option) => option.codigo) // Filtrar artículos sin código
      .map((option) => {
        const junta = option.codigo;
        const firstLetter = option.codigo[0]?.toUpperCase() || "#";
        return {
          firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
          ...option,
          junta,
        };
      });
  }, [articulos]);

  const options2 = useMemo(() => {
    return clientes
      .filter((option) => option.nombre_comercial) // Filtrar clientes sin nombre
      .map((option) => {
        const junta = (option.nombre_comercial || "") + " " + (option.codigo || "");
        const firstLetter = option.nombre_comercial?.[0]?.toUpperCase() || "#";
        return {
          firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
          ...option,
          junta,
        };
      });
  }, [clientes]);

  function jalaCliente(cliente) {
    setSelectedCliente(cliente._id);

    axios
      .get(`${URL_CLIENTES}/${cliente._id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCliente = res.data;
        setCliente(allCliente);
        setDescuento(allCliente.descuento || 0);

        // Validar existencia de arrays antes de acceder
        if (allCliente.vendedor && allCliente.vendedor.length > 0) {
          setSelectedColaborador(allCliente.vendedor[0]._id);
        }
        if (allCliente.departamentosClientes && allCliente.departamentosClientes.length > 0) {
          setDepartamentoCliente(allCliente.departamentosClientes[0]._id);
        }
        setClienteNombre((allCliente.codigo || "") + " " + (allCliente.nombre_comercial || ""));
        setListaPrecios(allCliente.listaPrecios || 1);
        if (allCliente.paqueterias && allCliente.paqueterias.length > 0) {
          setIdPaqueteria(allCliente.paqueterias[0]._id);
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo cargar la información del cliente",
        });
      });
  }

  function calculaImpuesto(e) {
    setSelectedImpuesto(e);
    if (e !== 0) {
      setIva((e * subTotal) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (e * subTotal) / 100 +
        subTotal -
        parseFloat(descuentoImporte) +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );
  }

  function jalaComisionTDC(e) {
    setComisionTDC(e);
    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * subTotal) / 100 +
        subTotal -
        parseFloat(descuentoImporte) +
        parseFloat(e) +
        parseFloat(comisionFlete)
    );
  }

  function jalaComisionFlete(e) {
    setComisionFlete(e);
    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * subTotal) / 100 +
        subTotal -
        parseFloat(descuentoImporte) +
        parseFloat(comisionTDC) +
        parseFloat(e)
    );
  }

  function autorizaCambio() {
    if (password === import.meta.env.VITE_PASSWORD_CAMBIA_PRECIO) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
      Swal.fire("Good job!", "Se autorizo con exito", "success");
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function solicitarAut() {
    setMailAutEnviado(true);

    axios.post(
      `${URL_WHATSAPP}SendMsg`,
      {
        number: import.meta.env.VITE_TELEFONO_SUPER_ADMIN,
        message: `Hola,
El Vendedor ${user.nombre} ${user.apellido} esta solicitando un cambio de precio.
Si lo autorizas proporciona la clave:
${randomCambiaPrecio}`,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    axios
      .post(
        URL_SEND_MAIL,
        {
          subject: "Cambio de Precio",
          email: import.meta.env.VITE_EMAIL_SUPER_ADMIN,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
       <th><img width="${
         import.meta.env.VITE_TAMANO_LOGO_MAIL
       }" align="center" src="${
            import.meta.env.VITE_LINK_SISTEMA
          }logoInstitucion.png" /></th>
       <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${
         import.meta.env.VITE_NOMBRE_INSTITUCION
       }</tr>
       <tbody>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>El vendedor ${
         user.nombre
       } ${
            user.apellido
          } esta solicitando un cambio de precio, si lo autorizas proporciona la clave ${randomCambiaPrecio}</tr>
       </tbody>
       <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${
         import.meta.env.VITE_TELEFONO_INSTITUCION
       }</tr>
       <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${
         import.meta.env.VITE_LINK_SISTEMA
       }Logo-Sistemify-PDF.png" /> </a> </tr>
       </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error al enviar solicitud",
          text: error.response?.data?.message || error.message || "No se pudo enviar la solicitud de autorización",
        });
        console.error("Error enviando solicitud de autorización:", error);
      });
  }

  const handleChangeInputProporcion = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        return { ...i, [event.target.name]: event.target.value };
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function BuscaArticuloProporcion(id, selectedArticulo) {
    if (!selectedArticulo) return;

    const foundArticle = articulos.find((a) => a._id === selectedArticulo._id);

    if (foundArticle) {
      const idArticulo = selectedArticulo._id;
      const articulosNombre = `${selectedArticulo.codigo} ${selectedArticulo.nombre}`;
      const colores = foundArticle.colores;
      const tallas = foundArticle.tallas;
      const precioArt = getPrecioSegunLista(foundArticle, listaPrecios);

      // Obtener foto del producto
      fetchProductPhoto(idArticulo);

      handleChangeInputArticuloProporcion(
        id,
        idArticulo,
        precioArt,
        articulosNombre,
        colores,
        tallas,
        "",
        foundArticle.precioEsp || "No"
      );
    } else {
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
    }
  }
  // Sanitizar código de barras para comparación consistente
  const sanitizeBarcode = (code) => {
    if (!code) return "";
    return code
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toUpperCase()
      .trim();
  };

  // Función para manejar Enter en el scanner (pistola envía Enter al final del código)
  const handleScannerKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      const value = scannerInputRef.current?.value || "";
      if (value.trim().length >= 2) {
        procesarCodigoScanner(value.trim());
      }
      // Limpiar el input para el siguiente scan
      if (scannerInputRef.current) {
        scannerInputRef.current.value = "";
      }
    }
  };

  // Función principal para procesar el código escaneado
  async function procesarCodigoScanner(scanValue) {
    // Validate the scan value exists
    if (!scanValue || scanValue.length < 2) {
      return;
    }

    // Note: inventory availability check is skipped if inventarios haven't loaded yet

    const sanitizedValue = sanitizeBarcode(scanValue);

    // Función auxiliar para buscar artículo
    const buscarArticulo = async () => {
      // Primero intentar por EAN exacto
      try {
        const resByEAN = await axios.get(
          `${URL_ARTICULOS_PROPORCION}/EAN/${scanValue}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_token")}`,
            },
          }
        );
        if (resByEAN.data) return resByEAN;
      } catch (error) {
        // EAN exacto no encontrado, intentar sanitizado
      }

      // Intentar por EAN sanitizado si es diferente al original
      if (sanitizedValue && sanitizedValue !== scanValue) {
        try {
          const resBySanitized = await axios.get(
            `${URL_ARTICULOS_PROPORCION}/EAN/${sanitizedValue}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_token")}`,
              },
            }
          );
          if (resBySanitized.data) return resBySanitized;
        } catch (error) {
          // EAN sanitizado tampoco encontrado
        }
      }

      // Si no se encuentra y es un ObjectId válido, intentar por _id
      const isValidObjectId = /^[a-fA-F0-9]{24}$/.test(scanValue);
      if (isValidObjectId) {
        try {
          const resById = await axios.get(
            `${URL_ARTICULOS_PROPORCION}/${scanValue}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_token")}`,
              },
            }
          );
          if (resById.data) return resById;
        } catch (error) {
          // ID tampoco encontrado
        }
      }

      return null;
    };

    const res = await buscarArticulo();

    if (!res || !res.data) {
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
      setManualInput((prev) => ({
        ...prev,
        idProporcion: "",
      }));
      return;
    }

    const {
      _id: idArticuloProporcion,
      articulos: [firstArticulo],
      colores,
      tallas,
    } = res.data;

    // Check if any required data is missing
    if (!firstArticulo || !colores.length || !tallas.length) {
      Swal.fire({
        icon: "error",
        title: "Datos incompletos",
        text: "El artículo no tiene datos completos de color o talla",
      });
      setManualInput((prev) => ({
        ...prev,
        idProporcion: "",
      }));
      return;
    }

    // Check for existing item - usar idArticuloProporcion correcto
    const existingItem = inputFields.find(
      (item) => item.idArticuloProporcion === idArticuloProporcion
    );

    if (existingItem) {
      // Check inventory availability before adding more
      const inventoryCheck = checkInventoryAvailability(
        existingItem.articulos,
        existingItem.idColor,
        existingItem.idTalla,
        existingItem.cantidad + 1
      );

      if (!inventoryCheck.available) {
        Swal.fire({
          icon: "error",
          title: "Inventario insuficiente",
          text: inventoryCheck.message,
          showConfirmButton: true,
        });
        setManualInput((prev) => ({
          ...prev,
          idProporcion: "",
        }));
        return;
      }

      const updatedFields = inputFields.map((field) => {
        if (field.idArticuloProporcion === idArticuloProporcion) {
          const newQuantity = field.cantidad + 1;
          return {
            ...field,
            cantidad: newQuantity,
            total: newQuantity * field.precio,
          };
        }
        return field;
      });
      setManualInput({
        articulosNombre: "",
        articulos: "",
        idColor: "",
        idTalla: "",
        tallaNombre: "",
        idProporcion: "",
        cantidad: 0,
        precio: 0,
        colores: [],
        tallas: [],
        total: 0,
        precioEsp: "No",
      });
      setInputFields(updatedFields);
      return;
    }

    // Check inventory availability for new item
    const inventoryCheck = checkInventoryAvailability(
      firstArticulo._id,
      colores[0]._id,
      tallas[0]._id,
      1
    );

    if (!inventoryCheck.available) {
      Swal.fire({
        icon: "error",
        title: "Inventario insuficiente",
        text: inventoryCheck.message,
        showConfirmButton: true,
      });
      setManualInput((prev) => ({
        ...prev,
        idProporcion: "",
      }));
      return;
    }

    const precioArt = getPrecioSegunLista(firstArticulo, listaPrecios);

    // Obtener foto del producto
    fetchProductPhoto(firstArticulo._id);

    // Create new item
    const newField = {
      id: uuidv4(),
      articulos: firstArticulo._id,
      articulosNombre: `${firstArticulo.codigo} ${firstArticulo.nombre}`,
      precio: precioArt,
      precioOriginal: precioArt,
      cantidad: 1,
      idTalla: tallas[0]._id,
      tallaNombre: tallas[0].name,
      idColor: colores[0]._id,
      colorNombre: colores[0].name,
      total: precioArt,
      colores: colores,
      tallas: tallas,
      idArticuloProporcion: idArticuloProporcion,
      precioEsp: firstArticulo.precioEsp || "No",
    };
    setManualInput({
      articulosNombre: "",
      articulos: "",
      idColor: "",
      idTalla: "",
      tallaNombre: "",
      idProporcion: "",
      cantidad: 0,
      precio: 0,
      colores: [],
      tallas: [],
      total: 0,
      precioEsp: "No",
    });
    setInputFields((prev) => [...prev, newField]);
  }

  const handleChangeInputArticuloProporcion = (
    id,
    idArticulo,
    precio,
    articulosNombre,
    colores,
    tallas,
    ean,
    precioEsp
  ) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        return {
          ...i,
          articulos: idArticulo,
          precio,
          articulosNombre,
          cajas: 0,
          colores,
          tallas,
          EAN: ean,
          precioEsp: precioEsp || "No"
        };
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
    ActualizaTotales();
  };

  function agregarProporcion(
    idArticulo,
    articulosNombre,
    precio,
    cajas,
    colores,
    tallas
  ) {
    axios
      .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;

        const avaible = inputFields.find((f) => String(f.articulos) === String(idArticulo));
        if (avaible) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Ya existe este articulo en la lista",
            showConfirmButton: false,
          });
          return;
        }

        // VALIDACIÓN DE INVENTARIO: Verificar disponibilidad por color y talla antes de agregar
        let validacionExitosa = true;
        let mensajeError = "";
        let cajasMaximasDisponibles = cajas; // Empezamos con las cajas solicitadas

        // Calcular el máximo de cajas que se pueden agregar basándose en el inventario mínimo
        for (const articulo of allArticulos) {
          // Validar que el artículo tenga colores y tallas
          if (!articulo.colores?.length || !articulo.tallas?.length) {
            validacionExitosa = false;
            mensajeError += `Artículo con datos incompletos (sin color o talla)\n`;
            continue;
          }

          const cantidadNecesaria = cajas * articulo.cantidad;
          const idColor = articulo.colores[0]._id;
          const idTalla = articulo.tallas[0]._id;

          // Validar inventario disponible
          const inventoryCheck = checkInventoryAvailability(idArticulo, idColor, idTalla, cantidadNecesaria);

          // Calcular cuántas cajas máximo se pueden hacer con este inventario
          const cajasMaximasParaEsteItem = Math.floor(inventoryCheck.availableQuantity / articulo.cantidad);

          // El cuello de botella determina el máximo de cajas totales
          if (cajasMaximasParaEsteItem < cajasMaximasDisponibles) {
            cajasMaximasDisponibles = cajasMaximasParaEsteItem;
          }

          if (!inventoryCheck.available) {
            validacionExitosa = false;
            mensajeError += `${articulo.colores[0].name} / ${articulo.tallas[0].name}: Necesitas ${cantidadNecesaria}, disponible ${inventoryCheck.availableQuantity}\n`;
          }
        }

        // Si la validación falla, ofrecer agregar lo disponible
        if (!validacionExitosa) {
          if (cajasMaximasDisponibles > 0) {
            // Hay algo disponible, ofrecer alternativa
            Swal.fire({
              icon: "warning",
              title: "Inventario insuficiente",
              html: `No hay suficiente inventario para ${cajas} cajas:<br><br>${mensajeError.replace(/\n/g, '<br>')}<br><strong>¿Deseas agregar ${cajasMaximasDisponibles} cajas que sí están disponibles?</strong>`,
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: `Sí, agregar ${cajasMaximasDisponibles} cajas`,
              cancelButtonText: "Cancelar",
            }).then((result) => {
              if (result.isConfirmed) {
                // Recursivamente llamar la función con las cajas disponibles
                agregarProporcion(
                  idArticulo,
                  articulosNombre,
                  precio,
                  cajasMaximasDisponibles,
                  colores,
                  tallas
                );
              }
            });
          } else {
            // No hay nada disponible
            Swal.fire({
              icon: "error",
              title: "Sin inventario disponible",
              text: `No hay inventario disponible para ninguna caja:\n${mensajeError}`,
              timer: 5000,
              showConfirmButton: true,
            });
          }
          return;
        }

        // Si llegamos aquí, la validación es exitosa, proceder a crear los artículos
        // Filtrar artículos sin colores o tallas
        const articulosValidos = allArticulos.filter((i) => i.colores?.length && i.tallas?.length);

        if (articulosValidos.length === 0) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No hay artículos válidos con color y talla definidos",
          });
          return;
        }

        const newInputFields = articulosValidos.map((i) => {
          return {
            id: uuidv4(),
            articulos: idArticulo,
            articulosNombre: articulosNombre,
            precio: precio,
            precioOriginal: precio,
            cantidad: cajas * i.cantidad,
            idTalla: i.tallas[0]._id,
            tallaNombre: i.tallas[0].name,
            idColor: i.colores[0]._id,
            colorNombre: i.colores[0].name,
            total: cajas * i.cantidad * precio,
            colores: colores,
            tallas: tallas,
            idArticuloProporcion: i._id,
            // Add a groupKey to help with visual grouping
            groupKey: `${articulosNombre}-${i.colores[0].name}`,
            isFirstInGroup: false, // We'll set this after sorting
            precioEsp: inputArticulos[0]?.precioEsp || "No",
          };
        });

        setInputFields((prevInputFields) => {
          const updatedInputFields = [...prevInputFields, ...newInputFields];

          // Sort using your existing order
          const sortedInputFields = updatedInputFields.sort((a, b) => {
            if (a.articulosNombre < b.articulosNombre) return -1;
            if (a.articulosNombre > b.articulosNombre) return 1;

            if (a.colorNombre < b.colorNombre) return -1;
            if (a.colorNombre > b.colorNombre) return 1;

            return (
              customSizeOrder.indexOf(a.tallaNombre) -
              customSizeOrder.indexOf(b.tallaNombre)
            );
          });

          // Mark first items in each group
          let currentGroup = "";
          sortedInputFields.forEach((field, index) => {
            if (field.groupKey !== currentGroup) {
              field.isFirstInGroup = true;
              currentGroup = field.groupKey;
            } else {
              field.isFirstInGroup = false;
            }
          });

          // Calculate totals
          const totalCantidad = sortedInputFields.reduce(
            (acc, curr) => acc + parseFloat(curr.cantidad),
            0
          );
          setTotalCantidad(totalCantidad);

          let importes = sortedInputFields.map((c) => parseFloat(c.total));
          let TG = importes.reduce((t, total) => t + total, 0);
          setSubTotal(TG);

          if (selectedImpuesto !== 0) {
            setIva((selectedImpuesto * TG) / 100);
          } else {
            setIva(0);
          }

          let temp1 = (TG * descuento) / 100;
          setDescuentoImporte(temp1);
          descuentoImporteRef.current = temp1;

          let totTemp =
            (selectedImpuesto * TG) / 100 +
            TG +
            parseFloat(comisionTDC) +
            parseFloat(comisionFlete) -
            parseFloat(temp1);
          setTotalGeneral(totTemp);

          return sortedInputFields;
        });

        setInputArticulos([
          {
            id: uuidv4(),
            articulos: "",
            cajas: 0,
            precio: 0,
            articulosNombre: "",
            colores: [],
            tallas: [],
            EAN: "",
            precioEsp: "No",
          },
        ]);
      })
      .catch((err) => {
        console.log(err);
      });
  }
   const handleCreateNewArticuloTalla = async(idArticulo, idColor, tallaNombre, cantidad, precio, colores) => {
      if (!cantidad || parseFloat(cantidad) <= 0) return;
  
      // Buscar la talla completa en el array de tallas
      const tallaCompleta = tallas.find(t => t.name === tallaNombre);
      if (!tallaCompleta) return;
  
      // Buscar el color completo en el array de colores del artículo
      const colorCompleto = colores.find(c => c._id === idColor);
      if (!colorCompleto) return;

      let res;

      try {
        res = await axios.get(
          `${URL_ARTICULOS_PROPORCION}/ArticuloColorTalla/${idArticulo}/${idColor}/${tallaCompleta._id}`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
      } catch (err) {
        console.log(err);
        return;
      }
      
      if (!res || !res.data || res.data.length === 0) {
        return;
      }
      
      let articuloProporcion = res.data[0];
  
      if (articuloProporcion.cantidad < parseFloat(cantidad)) {
        return;
      }

      // Check if this exact combination already exists
      const existingItem = inputFields.find(
        (item) => item.idArticuloProporcion === articuloProporcion._id
      );

      if (existingItem) {
        // Update existing item quantity
        const updatedFields = inputFields.map((field) => {
          if (field.idArticuloProporcion === articuloProporcion._id) {
            const newQuantity = field.cantidad + parseFloat(cantidad);
            return {
              ...field,
              cantidad: newQuantity,
              total: newQuantity * field.precio,
            };
          }
          return field;
        });
        setInputFields(updatedFields);
        ActualizaTotales();
        return;
      }
  
      // Buscar el artículo completo para obtener el código y nombre
      const articuloCompleto = articulos.find(a => a._id === idArticulo);
      if (!articuloCompleto) return;

      const newField = {
        id: uuidv4(),
        articulos: idArticulo,
        articulosNombre: `${articuloCompleto.codigo} ${articuloCompleto.nombre}`,
        precio: precio,
        precioOriginal: precio,
        cantidad: parseFloat(cantidad),
        idTalla: tallaCompleta._id,
        tallaNombre: tallaNombre,
        idColor: idColor,
        colorNombre: colorCompleto.name,
        total: parseFloat(cantidad) * precio,
        colores: colores,
        tallas: articuloCompleto.tallas || [],
        idArticuloProporcion: articuloProporcion._id,
        precioEsp: articuloCompleto.precioEsp || "No",
      };
  
      setInputFields((prevInputFields) => [...prevInputFields, newField]);
      ActualizaTotales();
    };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12 p-4">
          <h3 align="center">Nuevo Pedido</h3>
          {/* <Form > */}
          <Row>
            <Col md={2}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                disabled
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Buscar</Label>
              <Autocomplete
                size="small"
                value={value}
                onChange={(event, selectedCliente) => {
                  if (selectedCliente) {
                    jalaCliente(selectedCliente);
                  }
                }}
                options={options2.sort(
                  (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                )}
                groupBy={(option) => option.firstLetter}
                getOptionLabel={(option) => option?.junta || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Selecciona"
                    variant="outlined"
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props} key={option._id}>
                    {option.codigo} {option.nombre_comercial}
                  </li>
                )}
              />
            </Col>
            <Col md={3}>
              <Label>Cliente</Label>
              <Input
                type="text"
                placeholder="Cliente"
                value={clienteNombre}
                required
                disabled
              />
            </Col>
            <Col md={2}>
              <Label>Vendedor</Label>
              <Input
                type="select"
                value={selectedColaborador}
                // onChange={(e) => {
                //   setSelectedColaborador(e.target.value)
                // }}
                disabled
              >
                <option value="">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>

            <Col md={1}>
              <Label>Paqueteria</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={idPaqueteria}
                required
                onChange={(e) => {
                  setIdPaqueteria(e.target.value);
                }}
              >
                <option value="0">Selecciona </option>
                {paqueterias
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Surtir de Almacen</Label>
              <Input
                type="select"
                value={selectedArea}
                onChange={(e) => {
                  setSelectedArea(e.target.value);
                }}
              >
                <option value="">Selecciona un almacen</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.esTienda == "No") {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
            <Col md={1}>
              <Label>Comision TDC</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={comisionTDC}
                className={`form-control`}
                onValueChange={(value) => {
                  jalaComisionTDC(value);
                }}
              />
            </Col>
            <Col md={1}>
              <Label>Flete</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={comisionFlete}
                className={`form-control`}
                onValueChange={(value) => {
                  jalaComisionFlete(value);
                }}
              />
            </Col>

            <Col md={1}>
              <Label>Descuento %</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={descuento}
                onChange={(e) => setDescuento(e.target.value)}
                onBlur={(e) => calculaDescuento(e.target.value)}
              />
            </Col>
            <Col md={1}>
              <Label>Descuento $</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={descuentoImporte}
                onChange={(e) => setDescuentoImporte(e.target.value)}
                onBlur={(e) => calculaDescuentoImporte(e.target.value)}
              />
            </Col>

            <Col md={1}>
              <Label>Impuestos %</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={selectedImpuesto}
                onChange={(e) => {
                  calculaImpuesto(e.target.value);
                }}
              />
            </Col>

            <Col md={1}>
              <Label>Sub Total</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={subTotal}
                disabled
                className={`form-control`}
              />
            </Col>
            <Col md={1}>
              <Label>IVA</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={iva}
                disabled
                className={`form-control`}
              />
            </Col>
            <Col md={1}>
              <Label>Total</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={total_general}
                disabled
                className={`form-control`}
              />
            </Col>

            <Col md={1}>
              <Label>Piezas</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Piezas"
                value={total_cantidad}
                required
                disabled
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            <Col md={1}>
              <Label>Cambio de Precio</Label>
              <Button
                size="sm"
                className="btn"
                color="info"
                onClick={(e) => toggleCambiaPrecio()}
              >
                Solicitar
              </Button>
            </Col>
          </Row>
          <br />

          {/* FULL PRODUCT SECTION */}
          <h4 className="text-dark">
            <b>Agregar Caja</b>
          </h4>
          <>
            {/* QR Scanner Input */}
            <Row className=""></Row>

            {/* Proportion Input Section */}
            <Row className="">
              <Col md={1}>
                <Label className="mr-sm-2">QR</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Selecciona</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Foto</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Disponible</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cajas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio</Label>
              </Col>
              <Col md={1}>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={1}>
                <Input
                  name="articulos"
                  type="string"
                  value={inputArticulos[0]?.EAN}
                  onChange={(event) => {
                    BuscaCodigoProporcion(inputArticulos[0].id, event);
                  }}
                  disabled={selectedCliente == ""}
                ></Input>
              </Col>
              <Col md={2}>
                <Autocomplete
                  size="small"
                  value={inputArticulos[0]?.articulosNombre || ""}
                  onChange={(event, selectedArticulo) => {
                    BuscaArticuloProporcion(
                      inputArticulos[0]?.id || "template",
                      selectedArticulo
                    );
                  }}
                  options={options.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option?.junta || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option._id}>
                      {option.codigo} {option.nombre}
                    </li>
                  )}
                  disabled={selectedCliente == ""}
                />
              </Col>
              <Col md={1}>
                <div
                  style={{ minHeight: '30px', border: '1px solid #ccc', borderRadius: '4px', padding: '1px', backgroundColor: '#f8f9fa', position: 'relative' }}
                  onMouseEnter={(e) => {
                    const img = e.currentTarget.querySelector('img');
                    if (img) {
                      img.style.transform = 'scale(5)';
                      img.style.zIndex = '9999';
                      img.style.border = '2px solid #007bff';
                      img.style.boxShadow = '0 4px 15px rgba(0,123,255,0.4)';
                      img.style.objectFit = 'contain';
                      img.style.objectPosition = 'center';
                    }
                  }}
                  onMouseLeave={(e) => {
                    const img = e.currentTarget.querySelector('img');
                    if (img) {
                      img.style.transform = 'scale(1)';
                      img.style.zIndex = 'auto';
                      img.style.border = 'none';
                      img.style.boxShadow = 'none';
                      img.style.objectFit = 'cover';
                      img.style.objectPosition = 'center';
                    }
                  }}
                >
                  {inputArticulos[0]?.articulos && productPhotos[inputArticulos[0].articulos] ? (
                    <img
                      src={productPhotos[inputArticulos[0].articulos]}
                      alt="Producto"
                      style={{
                        width: '100%',
                        height: '40px',
                        objectFit: 'cover',
                        borderRadius: '2px',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        transformOrigin: 'center',
                        position: 'relative'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                  ) : null}
                  {inputArticulos[0]?.articulos && loadingPhotos[inputArticulos[0].articulos] ? (
                    <div style={{ textAlign: 'center', padding: '8px', fontSize: '8px' }}>
                      <small>...</small>
                    </div>
                  ) : !inputArticulos[0]?.articulos ? (
                    <div style={{ textAlign: 'center', padding: '8px', color: '#999', fontSize: '8px' }}>
                      <small>-</small>
                    </div>
                  ) : inputArticulos[0]?.articulos && !productPhotos[inputArticulos[0].articulos] && !loadingPhotos[inputArticulos[0].articulos] ? (
                    <div style={{ textAlign: 'center', padding: '8px', color: '#999', fontSize: '8px' }}>
                      <small>Sin foto</small>
                    </div>
                  ) : null}
                </div>
              </Col>
              <Col md={2}>
                <Input
                  name="articulosNombre"
                  type="string"
                  placeholder="Articulo"
                  value={inputArticulos[0]?.articulosNombre || ""}
                  disabled
                />
              </Col>
              <Col md={2}>
                <Input
                  type="text"
                  disabled
                  style={{ fontSize: "11px", padding: "4px" }}
                  value={
                    inputArticulos[0]?.articulos
                      ? (() => {
                          // Get all inventory items for this article
                          const inventoryItems = inventarios.filter((a) =>
                            String(a.idArticulo) === String(inputArticulos[0].articulos)
                          );

                          if (inventoryItems.length === 0) return "Sin stock";

                          // Group by color and create color: size|quantity pairs
                          const colorGroups = inventoryItems.reduce((acc, item) => {
                            if (item.disponible > 0) {
                              if (!acc[item.color]) {
                                acc[item.color] = [];
                              }
                              acc[item.color].push(`${item.talla}|${item.disponible}`);
                            }
                            return acc;
                          }, {});

                          // Format as "Color1: S|3,M|6; Color2: S|2,M|4"
                          const colorStrings = Object.entries(colorGroups)
                            .map(([color, sizes]) => `${color}: ${sizes.join(',')}`)
                            .join('; ');

                          return colorStrings || "Sin stock";
                        })()
                      : ""
                  }
                />
              </Col>
              <Col md={1}>
                <Input
                  name="cajas"
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Cajas"
                  value={inputArticulos[0]?.cajas || ""}
                  required
                  onChange={(event) =>
                    handleChangeInputProporcion(
                      inputArticulos[0]?.id || "template",
                      event
                    )
                  }
                />
              </Col>
              <Col md={1}>
                <PriceSelector
                  name="precio"
                  placeholder="Precio"
                  articulo={inputArticulos[0] ? articulos.find(a => String(a._id) === String(inputArticulos[0].articulos)) : null}
                  currentPrice={inputArticulos[0]?.precio || ""}
                  required
                  disabled={!user.cambiaPrecios && !cambiarPrecio && inputArticulos[0]?.precioEsp !== "Si"}
                  onChange={(event) =>
                    handleChangeInputPrecio(
                      inputArticulos[0]?.id || "template",
                      event
                    )
                  }
                />
              </Col>
              <Col md={1}>
                <Button
                  size="sm"
                  className="btn"
                  color="success"
                  disabled={
                    !inputArticulos[0]?.articulos ||
                    !inputArticulos[0]?.cajas ||
                    !inputArticulos[0]?.precio
                  }
                  onClick={() =>
                    agregarProporcion(
                      inputArticulos[0]?.articulos,
                      inputArticulos[0]?.articulosNombre,
                      inputArticulos[0]?.precio,
                      inputArticulos[0]?.cajas,
                      inputArticulos[0]?.colores,
                      inputArticulos[0]?.tallas
                    )
                  }
                  tabindex="-1"
                >
                  Agregar
                </Button>
              </Col>
            </Row>

            {/* MANUAL PRODUCT SECTION */}
            <h4 className="text-dark">
              <b>Agregar Pieza</b>
            </h4>
            <Row className="">
              <Col md={1}>
                <Label className="mr-sm-2">QR</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Selecciona</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Foto</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Disponible</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio</Label>
              </Col>
              <Col md={1}>
              </Col>
            </Row>

            <Row>
              <Col md={1}>
                <Input
                  name="scannerInput"
                  type="text"
                  placeholder="Escanear código"
                  innerRef={scannerInputRef}
                  onKeyDown={handleScannerKeyDown}
                  disabled={selectedCliente == ""}
                  autoComplete="off"
                ></Input>
              </Col>
              <Col md={2}>
                <Autocomplete
                  size="small"
                  value={manualInput?.articulosNombre || ""}
                  onChange={(event, selectedArticulo) => {
                    handleManualArticuloChange(selectedArticulo);
                  }}
                  options={options.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option?.junta || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option._id}>
                      {option.codigo} {option.nombre}
                    </li>
                  )}
                  disabled={selectedCliente == ""}
                />
              </Col>
              <Col md={1}>
                <div
                  style={{ minHeight: '30px', border: '1px solid #ccc', borderRadius: '4px', padding: '1px', backgroundColor: '#f8f9fa', position: 'relative' }}
                  onMouseEnter={(e) => {
                    const img = e.currentTarget.querySelector('img');
                    if (img) {
                      img.style.transform = 'scale(5)';
                      img.style.zIndex = '9999';
                      img.style.border = '2px solid #007bff';
                      img.style.boxShadow = '0 4px 15px rgba(0,123,255,0.4)';
                      img.style.objectFit = 'contain';
                      img.style.objectPosition = 'center';
                    }
                  }}
                  onMouseLeave={(e) => {
                    const img = e.currentTarget.querySelector('img');
                    if (img) {
                      img.style.transform = 'scale(1)';
                      img.style.zIndex = 'auto';
                      img.style.border = 'none';
                      img.style.boxShadow = 'none';
                      img.style.objectFit = 'cover';
                      img.style.objectPosition = 'center';
                    }
                  }}
                >
                  {manualInput.articulos && productPhotos[manualInput.articulos] ? (
                    <img
                      src={productPhotos[manualInput.articulos]}
                      alt="Producto"
                      style={{
                        width: '100%',
                        height: '40px',
                        objectFit: 'cover',
                        borderRadius: '2px',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        transformOrigin: 'center',
                        position: 'relative'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                  ) : null}
                  {manualInput.articulos && loadingPhotos[manualInput.articulos] ? (
                    <div style={{ textAlign: 'center', padding: '8px', fontSize: '8px' }}>
                      <small>...</small>
                    </div>
                  ) : !manualInput.articulos ? (
                    <div style={{ textAlign: 'center', padding: '8px', color: '#999', fontSize: '8px' }}>
                      <small>-</small>
                    </div>
                  ) : manualInput.articulos && !productPhotos[manualInput.articulos] && !loadingPhotos[manualInput.articulos] ? (
                    <div style={{ textAlign: 'center', padding: '8px', color: '#999', fontSize: '8px' }}>
                      <small>Sin foto</small>
                    </div>
                  ) : null}
                </div>
              </Col>
              <Col md={2}>
                <Input
                  type="text"
                  value={manualInput?.articulosNombre || ""}
                  disabled
                  style={{ fontSize: "10px" }}
                />
              </Col>
              <Col md={1}>
                <Input
                  name="idColor"
                  type="select"
                  value={manualInput?.idColor || ""}
                  onChange={handleManualInputChange}
                >
                  <option value="">Selecciona Color</option>
                  {manualInput?.colores?.map((color) => (
                    <option key={color._id} value={color._id}>
                      {color.name}
                    </option>
                  ))}
                </Input>
              </Col>
              <Col md={1}>
                <Input
                  name="idTalla"
                  type="select"
                  value={manualInput.idTalla || ""}
                  onChange={handleManualInputChange}
                >
                  <option value="">Selecciona Talla</option>
                  {manualInput.tallas &&
                    manualInput.tallas.map((talla) => (
                      <option key={talla._id} value={talla._id}>
                        {talla.name}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={1}>
                <Input
                  type="text"
                  disabled
                  style={{ fontSize: "9px", padding: "2px" }}
                  value={
                    manualInput?.articulos && manualInput?.idColor
                      ? (() => {
                          // Get all inventory items for this article and color
                          const inventoryItems = inventarios.filter((a) =>
                            String(a.idArticulo) === String(manualInput.articulos) &&
                            String(a.idColor) === String(manualInput.idColor)
                          );

                          if (inventoryItems.length === 0) return "Sin stock";

                          // Create size|quantity pairs
                          const sizeQuantities = inventoryItems
                            .filter(item => item.disponible > 0) // Only show sizes with stock
                            .map(item => `${item.talla}|${item.disponible}`)
                            .join(', ');

                          return sizeQuantities || "Sin stock";
                        })()
                      : ""
                  }
                />
              </Col>
              <Col md={1}>
                <Input
                  name="cantidad"
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Cantidad"
                  value={manualInput?.cantidad || 0}
                  disabled={!manualInput?.idColor || !manualInput?.idTalla}
                  onChange={handleManualInputChange}
                />
              </Col>
              <Col md={1}>
                <PriceSelector
                  name="precio"
                  articulo={manualInput?.articulos ? articulos.find(a => String(a._id) === String(manualInput.articulos)) : null}
                  currentPrice={manualInput?.precio || 0}
                  disabled={!user.cambiaPrecios && !cambiarPrecio && manualInput?.precioEsp !== "Si"}
                  onChange={handleManualInputChange}
                />
              </Col>
              <Col md={1}>
                <Button
                  size="sm"
                  className="btn"
                  color="success"
                  onClick={handleManualAdd}
                  disabled={
                    !manualInput?.articulosNombre ||
                    !manualInput?.idColor ||
                    !manualInput?.idTalla ||
                    !manualInput?.cantidad
                  }
                  tabindex="-1"
                >
                  Agregar
                </Button>
              </Col>
            </Row>
          </>

          <br />
          <hr />

          <div>
            {Object.entries(
              inputFields
                .filter((field) => field.articulosNombre && field.articulos)
                .reduce((acc, field) => {
                  const key = `${field.articulosNombre}`;
                  if (!acc[key]) {
                    acc[key] = {
                      articuloInfo: {
                        articulosNombre: field.articulosNombre,
                        articulos: field.articulos,
                        availableTallas: Array.from(
                          new Set(
                            inputFields
                              .filter(
                                (f) =>
                                  f.articulosNombre === field.articulosNombre
                              )
                              .map((f) => f.tallaNombre)
                              .filter(Boolean)
                              .sort((a, b) => {
                                return (
                                  customSizeOrder.indexOf(a) -
                                  customSizeOrder.indexOf(b)
                                );
                              })
                          )
                        ),
                      },
                      colorGroups: [],
                    };
                  }

                  const existingColorIndex = acc[key].colorGroups.findIndex(
                    (item) => String(item.idColor) === String(field.idColor)
                  );

                  if (existingColorIndex === -1) {
                    acc[key].colorGroups.push({
                      id: field.id,
                      articulos: field.articulos,
                      articulosNombre: field.articulosNombre,
                      idColor: field.idColor,
                      colorNombre: field.colorNombre,
                      colores: field.colores,
                      precioOriginal: field.precioOriginal,
                      precio: field.precio,
                      quantities: {
                        [field.tallaNombre]: {
                          cantidad: field.cantidad,
                          id: field.id,
                          cantInv: field.cantInv
                        },
                      },
                      total: field.cantidad * field.precio,
                    });
                  } else {
                   // If the size already exists for this color, sum the quantities
                    if (acc[key].colorGroups[existingColorIndex].quantities[field.tallaNombre]) {
                      acc[key].colorGroups[existingColorIndex].quantities[field.tallaNombre].cantidad += field.cantidad;
                    } else {
                      acc[key].colorGroups[existingColorIndex].quantities[field.tallaNombre] = {
                        cantidad: field.cantidad,
                        id: field.id,
                        cantInv: field.cantInv
                      };
                    }
                    acc[key].colorGroups[existingColorIndex].total +=
                      field.cantidad * field.precio;
                  }
                  return acc;
                }, {})
            ).map(([articuloNombre, { articuloInfo, colorGroups }]) => {
              // Calculate totals for this article
              const articleTotals = colorGroups.reduce(
                (totals, group) => {
                  const quantitySum = Object.values(group.quantities).reduce(
                    (sum, q) => sum + (parseFloat(q.cantidad) || 0),
                    0
                  );
                  const priceSum = Object.values(group.quantities).reduce(
                    (sum, q) =>
                      sum + (parseFloat(q.cantidad) || 0) * group.precio,
                    0
                  );

                  return {
                    items: totals.items + quantitySum,
                    price: totals.price + priceSum,
                    singlePrice: group.precio,
                  };
                },
                { items: 0, price: 0 }
              );

              return (
                <div key={articuloNombre} className="mb-8">
                  <div className="d-flex align-items-center border-t-2 border-gray-200 pt-2 pb-2 bg-gray-50">
                    <div className="d-flex align-items-center">
                      <Button
                        size="sm"
                        className="btn mr-3"
                        color="info"
                        onClick={() =>
                          setExpandedTables((prev) => ({
                            ...prev,
                            [articuloNombre]: !prev[articuloNombre],
                          }))
                        }
                      >
                        <i
                          className={`fas fa-chevron-${
                            expandedTables[articuloNombre] ? "up" : "down"
                          }`}
                        ></i>
                      </Button>
                      <h4 className="negrita mb-0 mr-4">{articuloNombre}</h4>
                    </div>
                    {!expandedTables[articuloNombre] && (
                      <div className="d-flex align-items-center">
                        <span
                          className="mr-4 text-dark"
                          style={{ fontSize: "18px" }}
                        >
                          <strong style={{ fontSize: "18px" }}>Piezas:</strong>{" "}
                          {articleTotals.items}
                        </span>
                        <span
                          className="mr-4 text-dark"
                          style={{ fontSize: "18px" }}
                        >
                          <strong style={{ fontSize: "18px" }}>Precio:</strong>{" "}
                          $
                          {articleTotals.singlePrice.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                        <span
                          className="text-dark"
                          style={{ fontSize: "18px" }}
                        >
                          <strong style={{ fontSize: "18px" }}>Total:</strong> $
                          {articleTotals.price.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    )}
                  </div>

                  {expandedTables[articuloNombre] && (
                    <Table borderless>
                      <thead>
                        <tr>
                          <th>Articulo</th>
                          <th>Color</th>
                          {articuloInfo.availableTallas.map((talla) => (
                            <th key={talla} style={{ maxWidth: "60px" }}>
                              {talla}
                            </th>
                          ))}
                          <th style={{ maxWidth: "120px" }}>Disponible</th>
                          <th style={{ maxWidth: "60px" }}>Precio Original</th>
                          <th style={{ maxWidth: "60px" }}>Precio</th>
                          <th style={{ maxWidth: "80px" }}>Total</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {colorGroups.map((group) => (
                          <tr key={`${group.id}-${group.idColor}`}>
                            {/* Your existing row content */}
                            <td>
                              <Input
                                name="articulo"
                                type="string"
                                placeholder="Articulo"
                                value={group.articulosNombre}
                                disabled
                              />
                            </td>
                            <td>
                              <Input
                                name="idColor"
                                type="select"
                                value={group.idColor}
                                onChange={(event) =>
                                  handleChangeInput(group.id, event)
                                }
                              >
                                <option value="">Selecciona</option>
                                {group.colores?.map((a) => (
                                  <option key={a._id} value={a._id}>
                                    {a.name}
                                  </option>
                                ))}
                              </Input>
                            </td>
                            {articuloInfo.availableTallas.map((talla) => (
                              <td key={talla} style={{ maxWidth: "60px" }}>
                                <Input
                                  name="cantidad"
                                  type="number"
                                  min="0"
                                  value={group.quantities[talla]?.cantidad || 0}
                                  disabled={group.is_active === "No"}
                                  onChange={(event) => {
                                    if (group.quantities[talla]?.id) {
                                      // Si existe el registro, usar la función existente
                                      handleChangeInputCantidad(
                                        group.quantities[talla].id,
                                        event
                                      );
                                    } else {
                                      // Si no existe el registro, crear uno nuevo
                                      handleCreateNewArticuloTalla(
                                        group.articulos,
                                        group.idColor,
                                        talla,
                                        event.target.value,
                                        group.precio,
                                        group.colores
                                      );
                                    }
                                  }}
                                />
                              </td>
                            ))}
                            <td style={{ maxWidth: "120px" }}>
                              <Input
                                type="text"
                                disabled
                                style={{ fontSize: "11px", padding: "2px" }}
                                value={
                                  (() => {
                                    // Get all inventory items for this article and color
                                    const inventoryItems = inventarios.filter((a) =>
                                      String(a.idArticulo) === String(group.articulos) &&
                                      String(a.idColor) === String(group.idColor)
                                    );

                                    if (inventoryItems.length === 0) return "Sin stock";

                                    // Create size|quantity pairs
                                    const sizeQuantities = inventoryItems
                                      .filter(item => item.disponible > 0) // Only show sizes with stock
                                      .map(item => `${item.talla}|${item.disponible}`)
                                      .join(', ');

                                    return sizeQuantities || "Sin stock";
                                  })()
                                }
                              />
                            </td>
                            <td style={{ maxWidth: "60px" }}>
                              <Input
                                name="precioOriginal"
                                type="number"
                                min="0"
                                step="any"
                                placeholder="PrecioOriginal"
                                value={group.precioOriginal}
                                disabled
                              />
                            </td>
                            <td style={{ maxWidth: "60px" }}>
                              <PriceSelector
                                style={
                                  group.precioOriginal - 50 > group.precio && group.precioEsp !== "Si"
                                    ? { backgroundColor: "#ed8c8c" }
                                    : null
                                }
                                name="precio"
                                placeholder="Precio"
                                articulo={articulos.find(a => String(a._id) === String(group.articulos))}
                                currentPrice={group.precio}
                                required
                                disabled={!user.cambiaPrecios && !cambiarPrecio && group.precioEsp !== "Si"}
                                onChange={(event) =>
                                  handleGroupPriceChange(group.id, event)
                                }
                              />
                            </td>
                            <td style={{ maxWidth: "80px" }}>
                              <Input
                                name="total"
                                type="number"
                                min="0"
                                step="any"
                                placeholder="total"
                                value={group.total}
                                disabled
                              />
                            </td>
                            <td>
                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                onClick={() => handleRemoveFields(group.id)}
                                tabindex="-1"
                              >
                                <i className="fas fa-minus"></i>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
              );
            })}
          </div>
          {/* </Form> */}
          {/* Termina Tabla Articulos */}

          <br />
          <Row className="align-items-center mt-3">
            <Col xs={3} className="text-dark" style={{ fontSize: "20px" }}>
              <span className="fw-bold">
                <b>Total Piezas:</b>{" "}
              </span>
              <span>
                {new Intl.NumberFormat("en-US").format(total_cantidad)}
              </span>
            </Col>
            <Col xs={3} className="text-dark" style={{ fontSize: "20px" }}>
              <span className="fw-bold">
                <b>Subtotal:</b>{" "}
              </span>
              <span>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(subTotal)}
              </span>
            </Col>
            <Col xs={3} className="text-dark" style={{ fontSize: "20px" }}>
              <span className="fw-bold">
                <b>IVA:</b>{" "}
              </span>
              <span>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(iva)}
              </span>
            </Col>
            <Col xs={3} className="text-dark" style={{ fontSize: "20px" }}>
              <span className="fw-bold">
                <b>Total:</b>{" "}
              </span>
              <span>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(total_general)}
              </span>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={1}>
              {validaBoton && inputFields.some((c) => c.cantidad > 0)? (
                <Button
                  type="button"
                  className="btn btn-success"
                  tabIndex={-1}
                  onClick={savePedido}
                >
                  Guardar
                </Button>
              ) : (
                <Button type="button" className="btn btn-success" disabled>
                  Guardar
                </Button>
              )}
            </Col>
            <Col md={1}>
              <Button
                href="/ListadoPedidos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          {/* </Form> */}
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

          <Modal
            size="sm"
            isOpen={modalCambiaPrecio}
            toggle={toggleCambiaPrecio}
          >
            <ModalHeader toggle={toggleCambiaPrecio}>
              <h4>Autorizar Precio</h4>
            </ModalHeader>
            <ModalBody>
              {mailAutEnviado === false ? (
                <Col>
                  <Button
                    type="button"
                    className="btn btn-success"
                    onClick={(e) => solicitarAut()}
                  >
                    Solicitar Autorizacion
                  </Button>
                </Col>
              ) : (
                <>
                  <Input
                    bsSize="sm"
                    type="password"
                    placeholder="Password"
                    value={password}
                    required
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <br />
                  <Row>
                    <Col>
                      <Button
                        type="button"
                        className="btn btn-success"
                        onClick={(e) => autorizaCambio()}
                      >
                        Autorizar
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        type="button"
                        className="btn btn-success"
                        onClick={(e) => solicitarAut()}
                      >
                        Reenviar Solicitud
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default PedidosCreate;
